import {
  domainRedirectComponentFactory,
  domainRouteComponentFactory,
} from '@retailer-platform/dashboard/routing'
import { type DomainRouteName } from '../../routing/routes'
import { type DomainAccessControlConfig } from './accessControl'

// Mirrors customers-and-orders/.../routingComponents.tsx — the canonical way to
// obtain DomainRoute / DomainRedirect strongly typed against this domain's
// route identifiers and access-control shape.
export const DomainRoute = domainRouteComponentFactory<DomainRouteName, DomainAccessControlConfig>()
export const DomainRedirect = domainRedirectComponentFactory<
  DomainRouteName,
  DomainAccessControlConfig
>()
